import { FunctionComponent, ReactNode } from "react";
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalBody,
  ModalFooter,
  Box,
} from "@chakra-ui/react";

import { Button } from "src/components";

import { size } from "src/types/size";

type Props = {
  title: string;
  size: size;
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  modalActionLabel?: string;
  closeOnOverlayClick?: boolean;
  isModalAction?: boolean;
  isCentered?: boolean;
  scrollBehavior?: "inside" | "outside";
};

export const CustomModal: FunctionComponent<Props> = ({
  title,
  size,
  isOpen,
  onClose = () => console.log("closed"),
  isModalAction,
  modalActionLabel,
  isCentered,
  scrollBehavior,
  children,
}) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      isCentered={isCentered}
      scrollBehavior={scrollBehavior}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontWeight={400} fontSize={"14px"}>
          <Box as="span" borderBottom="1px solid red" pb={2}>
            {title}
          </Box>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody mb={6}>{children}</ModalBody>
        {isModalAction && (
          <ModalFooter>
            <Button label={modalActionLabel} />
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
